import { render, staticRenderFns } from "./NewImagesHandler.vue?vue&type=template&id=89d7339a&scoped=true&"
import script from "./NewImagesHandler.vue?vue&type=script&lang=js&"
export * from "./NewImagesHandler.vue?vue&type=script&lang=js&"
import style0 from "./NewImagesHandler.vue?vue&type=style&index=0&id=89d7339a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d7339a",
  null
  
)

export default component.exports